import { Theme, LoaderEmphasis } from "../types";
import styles from "./ellipseColor.module.scss";

type EllipseVariation = {
  emphasis: LoaderEmphasis;
  theme: Theme;
};

type Style = { style: string };

const grayEllipse = styles.grayEllipse;
const gladiatorEllipse = styles.gladiatorEllipse;
const whiteEllipse = styles.whiteEllipse;
const navyLightEllipse = styles.navyLightEllipse;

const ellipseVariations: (EllipseVariation & Style)[] = [
  { theme: "core", emphasis: "default", style: grayEllipse },
  { theme: "core", emphasis: "negative", style: whiteEllipse },
  { theme: "core", emphasis: "primary", style: gladiatorEllipse },
  { theme: "trainer", emphasis: "default", style: grayEllipse },
  { theme: "trainer", emphasis: "primary", style: navyLightEllipse },
];

export const ellipseColor = (ellipseVariation: EllipseVariation) => {
  const ellipse = ellipseVariations.find(
    (variation) =>
      variation.theme === ellipseVariation.theme &&
      variation.emphasis === ellipseVariation.emphasis
  );

  return ellipse.style || grayEllipse;
};
